import { observer } from 'mobx-react-lite';
import Icon from '@components/core/icon/icon.tsx';
import { IconEnum } from '@components/core/icon/icon-enum.ts';
import Tooltip from '@components/core/tooltip/tooltip.tsx';

const InternalOnlyIndicator = observer(function InternalOnlyIndicator() {
	return (
		<Tooltip text={'Internal Only'} direction={'bottom'}>
			<Icon icon={IconEnum.VERIFIED_USER} size={'1rem'} />
		</Tooltip>
	);
});

export default InternalOnlyIndicator;
